import React from 'react';
import { useNavigate } from 'react-router-dom';
import { solutionColors } from '../styles/solutions';
import ProductHero from '../components/ProductPage/ProductHero';
import FeaturesSection from '../components/ProductPage/FeaturesSection';
import BenefitsSection from '../components/ProductPage/BenefitsSection';
import CTASection from '../components/ProductPage/CTASection';
import {
  AgentIcon,
  AutomationIcon,
  LearningIcon,
  IntegrationIcon,
  SpeedIcon,
  CostIcon,
  ScalabilityIcon,
  InsightIcon,
} from '../components/ProductPage/icons';

const AgentesPage: React.FC = () => {
  const navigate = useNavigate();
  const color = solutionColors.agentes;

  const scrollToContact = () => {
    navigate('/contato');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goToHome = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('solutions');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const features = [
    {
      icon: <AutomationIcon />,
      title: 'Automação Inteligente',
      description: 'Vai além do RPA tradicional com agentes que entendem contexto, aprendem com dados e tomam decisões complexas em tempo real.',
    },
    {
      icon: <LearningIcon />,
      title: 'Aprendizado Contínuo',
      description: 'Agentes que evoluem com seu negócio, adaptando-se automaticamente a novos padrões e otimizando processos sem intervenção manual.',
    },
    {
      icon: <IntegrationIcon />,
      title: 'Integração Nativa',
      description: 'Conecta-se facilmente aos seus sistemas existentes através de APIs, webhooks e conectores pré-configurados para as principais plataformas.',
    },
  ];

  const benefits = [
    {
      icon: <SpeedIcon />,
      title: 'Agilidade Operacional',
      description: 'Redução de até 80% no tempo de processamento de tarefas repetitivas, liberando sua equipe para atividades estratégicas.',
    },
    {
      icon: <CostIcon />,
      title: 'Redução de Custos',
      description: 'Economia significativa em operações manuais, com ROI mensurável já nos primeiros 3 meses de implementação.',
    },
    {
      icon: <ScalabilityIcon />,
      title: 'Escalabilidade Sem Limites',
      description: 'Capacidade de processar milhares de tarefas simultaneamente, crescendo conforme a demanda do seu negócio.',
    },
    {
      icon: <InsightIcon />,
      title: 'Insights Acionáveis',
      description: 'Análise em tempo real de padrões e anomalias, gerando alertas e recomendações para decisões mais inteligentes.',
    },
  ];

  return (
    <>
      <ProductHero
        icon={<AgentIcon />}
        title="<span class='highlight'>Agentes Inteligentes</span><br />para automação estratégica"
        subtitle="Automação que aprende e se adapta ao seu negócio"
        description="Desenvolvemos agentes de IA que vão muito além da automação tradicional. Nossas soluções entendem contexto, aprendem com dados históricos e tomam decisões inteligentes em tempo real, transformando processos operacionais em vantagens competitivas."
        color={color}
        onPrimaryClick={scrollToContact}
        primaryButtonText="Fale Conosco"
      />

      <FeaturesSection
        title="Como nossos agentes funcionam"
        subtitle="Tecnologia de ponta para automação que realmente entende seu negócio"
        features={features}
        color={color}
      />

      <BenefitsSection
        title="Benefícios reais para seu negócio"
        subtitle="Resultados mensuráveis que impactam diretamente seus indicadores"
        benefits={benefits}
        color={color}
      />

      <CTASection
        title="Pronto para automatizar com inteligência?"
        description="Converse com nossos especialistas e descubra como agentes inteligentes podem transformar seus processos operacionais em vantagem competitiva."
        color={color}
        primaryButtonText="Agendar Conversa"
        secondaryButtonText="Ver Outras Soluções"
        onPrimaryClick={scrollToContact}
        onSecondaryClick={goToHome}
      />
    </>
  );
};

export default AgentesPage;


